import { render, staticRenderFns } from "./delivery-hayes.vue?vue&type=template&id=35df5f50"
import script from "./delivery-hayes.vue?vue&type=script&lang=js"
export * from "./delivery-hayes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports